import { useEffect, useRef } from 'react';

import { useTranslate } from '../translate';

interface OptionsDropdownProps {
  isOpen: boolean;
  helpMeGetStarted: () => void;
  toggleOptions: () => void;
  resetConversation: () => void;
}

export function OptionsDropdown({
  isOpen,
  helpMeGetStarted,
  toggleOptions,
  resetConversation,
}: OptionsDropdownProps) {
  const translate = useTranslate();
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!isOpen) return;

    document.addEventListener('mousedown', closeOnOutsideClick);
    return () => document.removeEventListener('mousedown', closeOnOutsideClick);

    function closeOnOutsideClick(event: MouseEvent) {
      if (!containerRef.current?.contains(event.target as Node)) {
        toggleOptions();
      }
    }
  }, [isOpen, toggleOptions]);

  return (
    <div
      ref={containerRef}
      className={`jr-dropdown-container${isOpen ? ' show' : ''}`}
    >
      <button
        type="button"
        className="jr-ai-assist-button s ghost"
        aria-label={translate('moreOptions')}
        onClick={toggleOptions}
      >
        <i className="jr-ai-icon jr-ai-icon-more-horizontal" />
      </button>

      <div className="jr-dropdown-menu right">
        <ul className="jr-dropdown-menu-list" role="menu">
          <MenuItem
            onClick={helpMeGetStarted}
            iconClassName="jr-ai-icon-question-circle"
            label={translate('help')}
          />

          <MenuItem
            onClick={resetConversationHandler}
            iconClassName="jr-ai-icon-bin"
            label={translate('resetConversation')}
          />
        </ul>
      </div>
    </div>
  );

  function resetConversationHandler() {
    toggleOptions();
    resetConversation();
  }
}

function MenuItem({
  onClick,
  iconClassName,
  label,
}: {
  onClick: () => void;
  iconClassName: string;
  label: string;
}) {
  return (
    <li
      className="jr-dropdown-menu-item"
      role="menuitem"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={handleKeyDown}
    >
      <i className={`jr-ai-icon ${iconClassName}`} />
      <span className="jr-dropdown-label">{label}</span>
    </li>
  );

  function handleKeyDown(event: React.KeyboardEvent) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onClick();
    }
  }
}
